import React from 'react';

export const MyGroupsIcon = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
			<circle cx="15" cy="15" r="14" fill="white" stroke="#FFC001" stroke-width="2" />
			<svg xmlns="http://www.w3.org/2000/svg" width="30" height="41" viewBox="0 0 29 18" fill="none">
				<path d="M7.5 16.5L11 18H13.5H16.5L21 16.5L25 13L27 9.5L28.5 0.5C17.4422 5.17668 10.8038 5.47098 0 0.5L1 9L2.5 12L4.5 14.5L7.5 16.5Z" fill="#FFC001" />
			</svg>
		</svg>
	);
};
